import React from "react"
import { ThemeProvider } from "theme-ui"
import {
  Routes,
  Route
} from "react-router-dom"
import { CookiesProvider } from "react-cookie"

import Layout from "./pages/Layout/Layout"
import RemoteLayout from "./pages/RemoteLayout/RemoteLayout"
import Settings from "./pages/Settings/Settings"
import MessengerLayout from "./pages/MessengerLayout/MessengerLayout"
import Messenger from "./pages/Messenger/Messenger"
import WebchatButton from "./pages/WebchatButton/WebchatButton"
// import Inbox from "./pages/Inbox/Inbox"

import "./App.css"
import theme from "./stylesheets/theme"

function App() {
  return (
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/messenger" element={<MessengerLayout />}>
            <Route index element={<Messenger />} />
            <Route path="webchat_button/" element={<WebchatButton />} />
          </Route>
          <Route path="/portal" element={<Layout />}>
            <Route path="settings/" element={<Settings />} />
          </Route>
          <Route path="/remote" element={<RemoteLayout />}>
            <Route path="settings/" element={<Settings />} />
          </Route>
        </Routes>
      </ThemeProvider>
    </CookiesProvider>
  )
}

export default App;
